module.exports = __webpack_public_path__ + "svg/book.f6cbc0c6ec9332b6fc41e8ec4fb05b30.svg";